export default __webpack_public_path__ + "b6279dbd27fdd89ac10f46ce69c8b370.png";